import { IHoliday } from "../holidayTypes";

export const GermanyHolidays: { [key: string]: IHoliday } = {
  // 2024
  "2024-01-01": { title: "Neujahrstag", type: "HOLIDAY" },
  "2024-01-06": { title: "Heilige Drei Könige", type: "SPECIAL_DAY" }, // Endast i Bayern, Baden-Württemberg, etc.
  "2024-03-29": { title: "Karfreitag", type: "HOLIDAY" },
  "2024-03-31": { title: "Ostersonntag", type: "SPECIAL_DAY" }, // Endast i Brandenburg
  "2024-04-01": { title: "Ostermontag", type: "HOLIDAY" },
  "2024-05-01": { title: "Tag der Arbeit", type: "HOLIDAY" },
  "2024-05-09": { title: "Christi Himmelfahrt", type: "HOLIDAY" },
  "2024-05-19": { title: "Pfingstsonntag", type: "SPECIAL_DAY" }, // Endast i Brandenburg
  "2024-05-20": { title: "Pfingstmontag", type: "HOLIDAY" },
  "2024-05-30": { title: "Fronleichnam", type: "SPECIAL_DAY" }, // Endast i katolska regioner
  "2024-10-03": { title: "Tag der Deutschen Einheit", type: "HOLIDAY" },
  "2024-10-31": { title: "Reformationstag", type: "SPECIAL_DAY" }, // Endast i vissa länder
  "2024-11-01": { title: "Allerheiligen", type: "SPECIAL_DAY" }, // Endast i katolska områden
  "2024-12-25": { title: "Erster Weihnachtstag", type: "HOLIDAY" },
  "2024-12-26": { title: "Zweiter Weihnachtstag", type: "HOLIDAY" },
  "2024-12-31": { title: "Silvester", type: "SPECIAL_DAY" }, // Inte officiellt, men allmänt firad

  // 2025
  "2025-01-01": { title: "Neujahrstag", type: "HOLIDAY" },
  "2025-01-06": { title: "Heilige Drei Könige", type: "SPECIAL_DAY" },
  "2025-04-18": { title: "Karfreitag", type: "HOLIDAY" },
  "2025-04-20": { title: "Ostersonntag", type: "SPECIAL_DAY" },
  "2025-04-21": { title: "Ostermontag", type: "HOLIDAY" },
  "2025-05-01": { title: "Tag der Arbeit", type: "HOLIDAY" },
  "2025-05-29": { title: "Christi Himmelfahrt", type: "HOLIDAY" },
  "2025-06-08": { title: "Pfingstsonntag", type: "SPECIAL_DAY" },
  "2025-06-09": { title: "Pfingstmontag", type: "HOLIDAY" },
  "2025-06-19": { title: "Fronleichnam", type: "SPECIAL_DAY" },
  "2025-10-03": { title: "Tag der Deutschen Einheit", type: "HOLIDAY" },
  "2025-10-31": { title: "Reformationstag", type: "SPECIAL_DAY" },
  "2025-11-01": { title: "Allerheiligen", type: "SPECIAL_DAY" },
  "2025-11-19": { title: "Buß- und Bettag", type: "SPECIAL_DAY" }, // Endast i Sachsen
  "2025-12-25": { title: "Erster Weihnachtstag", type: "HOLIDAY" },
  "2025-12-26": { title: "Zweiter Weihnachtstag", type: "HOLIDAY" },
  "2025-12-31": { title: "Silvester", type: "SPECIAL_DAY" },

  // 2026
  "2026-01-01": { title: "Neujahrstag", type: "HOLIDAY" },
  "2026-01-06": { title: "Heilige Drei Könige", type: "SPECIAL_DAY" },
  "2026-04-03": { title: "Karfreitag", type: "HOLIDAY" },
  "2026-04-05": { title: "Ostersonntag", type: "SPECIAL_DAY" },
  "2026-04-06": { title: "Ostermontag", type: "HOLIDAY" },
  "2026-05-01": { title: "Tag der Arbeit", type: "HOLIDAY" },
  "2026-05-14": { title: "Christi Himmelfahrt", type: "HOLIDAY" },
  "2026-05-24": { title: "Pfingstsonntag", type: "SPECIAL_DAY" },
  "2026-05-25": { title: "Pfingstmontag", type: "HOLIDAY" },
  "2026-06-04": { title: "Fronleichnam", type: "SPECIAL_DAY" },
  "2026-10-03": { title: "Tag der Deutschen Einheit", type: "HOLIDAY" },
  "2026-10-31": { title: "Reformationstag", type: "SPECIAL_DAY" },
  "2026-11-01": { title: "Allerheiligen", type: "SPECIAL_DAY" },
  "2026-11-18": { title: "Buß- und Bettag", type: "SPECIAL_DAY" },
  "2026-12-25": { title: "Erster Weihnachtstag", type: "HOLIDAY" },
  "2026-12-26": { title: "Zweiter Weihnachtstag", type: "HOLIDAY" },
  "2026-12-31": { title: "Silvester", type: "SPECIAL_DAY" },

  // 2027
  "2027-01-01": { title: "Neujahrstag", type: "HOLIDAY" },
  "2027-01-06": { title: "Heilige Drei Könige", type: "SPECIAL_DAY" },
  "2027-03-26": { title: "Karfreitag", type: "HOLIDAY" },
  "2027-03-28": { title: "Ostersonntag", type: "SPECIAL_DAY" },
  "2027-03-29": { title: "Ostermontag", type: "HOLIDAY" },
  "2027-05-01": { title: "Tag der Arbeit", type: "HOLIDAY" },
  "2027-05-06": { title: "Christi Himmelfahrt", type: "HOLIDAY" },
  "2027-05-16": { title: "Pfingstsonntag", type: "SPECIAL_DAY" },
  "2027-05-17": { title: "Pfingstmontag", type: "HOLIDAY" },
  "2027-05-27": { title: "Fronleichnam", type: "SPECIAL_DAY" },
  "2027-10-03": { title: "Tag der Deutschen Einheit", type: "HOLIDAY" },
  "2027-10-31": { title: "Reformationstag", type: "SPECIAL_DAY" },
  "2027-11-01": { title: "Allerheiligen", type: "SPECIAL_DAY" },
  "2027-11-17": { title: "Buß- und Bettag", type: "SPECIAL_DAY" },
  "2027-12-25": { title: "Erster Weihnachtstag", type: "HOLIDAY" },
  "2027-12-26": { title: "Zweiter Weihnachtstag", type: "HOLIDAY" },
  "2027-12-31": { title: "Silvester", type: "SPECIAL_DAY" },
};



// WEBPACK FOOTER //
// ./src/constants/holidays/europe/germanyHolidays.ts